import { httpGet, httpPost } from "../Web";
import { ApiResponse } from "./ApiResponse";
import { WorkshopProductStatus, ProductReleaseStatus } from "./WorkshopProducts";
import { WorkshopProductPairProperty } from "./WSTestingData";
import { TestSupportStatus } from "./WorkshopTestCases";

//import { FieldType } from "./Interface";
//import { WorkshopTestResult } from "./WorkshopResult";

export interface WSConfigTreeKey {
    workshopProductId: number;
    wsTreeEntryType: number;
    testCombinationId: number;
}

export interface WSConfigTreeData {
    testCasesSum: number;
    testCasesMarked: number;
    treeNodeName: string;
    alternateIcon: boolean;
    key: WSConfigTreeKey;
}

export interface WSConfigTestCaseData {
    wstcId: number;
    workshopProductId: number;
    testCaseId: number;
    testCombinationId: number;
    interfaceId: number;
    sortOrder: number;
    group: string;
    name: string;
    description: string;
    supportStatus: TestSupportStatus;
}

export interface WSConfigTestCaseGroup {
    group: string;
    testCases: WSConfigTestCaseData[];
}

export interface WSConfigCombinationIfaceData {
    interfaceId: number;
    wPIfaceID: number;
    interfaceName: string;
    serverEndpoint: string;
    supportedByProduct: boolean;
    properties: WorkshopProductPairProperty[];
    testCaseGroups: WSConfigTestCaseGroup[];
}

export interface WSConfigCombinationData {
    testCombinationId: number;
    combinationName: string;
    combinationProvider: string;
    combinationConsumer: string;
    isProvider: boolean;
    isConsumer: boolean;
    providerReadyToTest: boolean;
    consumerReadyToTest: boolean;
}

export interface WSConfigProductData {
    combinationTypeName: string;
    combinationName: string;
    productName: string;
    productVersion: string;
    description: string;
    workshopId: number;
    productId: number;
    workshopProductId: number;
    workshopProductCombinationId: number;
    status: WorkshopProductStatus,
    releaseStatus: ProductReleaseStatus,
    readyToTest: boolean;
    key: WSConfigTreeKey;
    combinationIfaces: WSConfigCombinationIfaceData[];
    combinationData: WSConfigCombinationData[];
}

export const GetEmptyTestingKey = () => {
    let keyVal: WSConfigTreeKey = {
        workshopProductId: 0,
        wsTreeEntryType: 0,
        testCombinationId: 0,
    }
    return keyVal;
}

export const getWorkshopConfigTree = (workshopId: number, abortController: AbortController): Promise<ApiResponse<WSConfigTreeData[]>> =>
    httpGet(`/api/workshopconfig/getconfigtree/${workshopId}`, abortController);

export const getconfigproduct = (productkey: string, abortController: AbortController): Promise<ApiResponse<WSConfigProductData>> =>
    httpGet(`/api/workshopconfig/getconfigproduct/${productkey}`, abortController);
